const override = false;
const config = {
    development: {
        LOCATION_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com/locations',
        WHATSAPP_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com/phone-system/whatsapp/location',
        BASE_URL: 'http://localhost:5108',
        MEDIA_CENTER_URL: 'https://hl-media-center.web.app',
        DEPLOYMENT_URL: 'http://localhost:5500/',
        CUSTOM_FIELDS_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com/locations',
    },
    staging: {
        LOCATION_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com/locations',
        WHATSAPP_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com/phone-system/whatsapp/location',
        BASE_URL: 'https://staging.services.leadconnectorhq.com',
        MEDIA_CENTER_URL: 'https://hl-media-center.web.app',
        DEPLOYMENT_URL: 'https://storage.googleapis.com/staging-leadconnector/',
        CUSTOM_FIELDS_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com/locations',
    },
    production: {
        LOCATION_SERVICE_URL: 'https://backend.leadconnectorhq.com/locations',
        WHATSAPP_SERVICE_URL: 'https://backend.leadconnectorhq.com/phone-system/whatsapp/location',
        BASE_URL: 'https://services.leadconnectorhq.com',
        MEDIA_CENTER_URL: 'https://media-center-prod.web.app',
        DEPLOYMENT_URL: 'https://widgets.leadconnectorhq.com/',
        CUSTOM_FIELDS_SERVICE_URL: 'https://backend.leadconnectorhq.com/locations',
    },
};
if (override) {
    // do overrides here
}
export default config[process.env.mode];
